import React from "react";

const Ranking = () => {
	return <div>Ranking</div>;
};

export default Ranking;
